import { Role } from '@/model/role';
import type { RouteRecordRaw } from 'vue-router';
const BookingConfirmation = () =>
  import('@/components/bookings/BookingConfirmation.vue');
const AddBooking = () => import('@/components/bookings/AddBooking.vue');
const PublicBooking = () => import('@/components/bookings/PublicBooking.vue');

const bookingsRoutes: RouteRecordRaw[] = [
  {
    path: '/:lang?/:vendor_slug/:location_slug/book',
    name: 'PublicBooking',
    component: PublicBooking,
    meta: {
      customer: true,
      role: Role.GUEST,
    },
  },
  {
    path: '/:vendor_slug/:location_slug?/book',
    name: 'CustomerPublicBooking',
    component: PublicBooking,
    meta: {
      customer: true,
      role: Role.CUSTOMER,
    },
  },
  {
    path: '/bookings/add',
    name: 'AddBooking',
    component: AddBooking,
    meta: {
      role: Role.STAFF,
    },
  },
  {
    path: '/bookings/edit',
    name: 'EditBooking',
    component: AddBooking,
    meta: {
      role: Role.STAFF,
    },
  },
  {
    path: '/bookings/confirmation',
    name: 'BookingConfirmation',
    component: BookingConfirmation,
    meta: {
      role: Role.STAFF,
    },
  },
  {
    path: '/bookings/confirmation',
    name: 'PublicBookingConfirmation',
    component: BookingConfirmation,
    meta: {
      customer: true,
      role: Role.CUSTOMER,
    },
  },
];

export default bookingsRoutes;
